export default __webpack_public_path__ + "static/media/reportIcon.31c3caa5.svg";